(() => {
  var __defProp = Object.defineProperty;
  var __export = (target, all) => {
    for (var name in all)
      __defProp(target, name, { get: all[name], enumerable: true });
  };

  // work/global-launch-options-2026-11-03/mixed-envelope/src/ceika-cart-lock.mjs
  var CART_LOCK_NAME = "ceika-configuration-cart";
  var queueKey = Symbol.for("ceika.configuration.cart.queue");
  function withCartLock(callback) {
    if (globalThis.navigator?.locks?.request) return globalThis.navigator.locks.request(CART_LOCK_NAME, callback);
    const next = (globalThis[queueKey] || Promise.resolve()).then(callback);
    globalThis[queueKey] = next.catch(() => {
    });
    return next;
  }

  // work/global-launch-options-2026-11-03/mixed-envelope/src/legacy-wire-v2.mjs
  var legacy_wire_v2_exports = {};
  __export(legacy_wire_v2_exports, {
    MAX_TEXT_BYTES: () => MAX_TEXT_BYTES2,
    MAX_TEXT_RECORDS: () => MAX_TEXT_RECORDS2,
    TEXT_KEY: () => TEXT_KEY2,
    WIRE_KEY: () => WIRE_KEY2,
    compileWirePolicy: () => compileWirePolicy,
    createWireDictionary: () => createWireDictionary,
    decodeWireSelection: () => decodeWireSelection2,
    encodeWireSelection: () => encodeWireSelection,
    expandWirePolicy: () => expandWirePolicy,
    nonceForBuild: () => nonceForBuild,
    parseTextEnvelope: () => parseTextEnvelope,
    parseWireToken: () => parseWireToken2,
    stageTextRecord: () => stageTextRecord2,
    writeTextEnvelope: () => writeTextEnvelope
  });

  // work/global-launch-options-2026-11-03/mixed-envelope/src/ceika-cart-envelope.mjs
  var WIRE_KEY = "_ceika_wire_v2";
  var TEXT_KEY = "_ceika_text_v2";
  var MAX_TEXT_BYTES = 8192;
  var MAX_TEXT_RECORDS = 12;
  var check = (ok, error) => {
    if (!ok) throw Error(error);
  };
  var object = (v) => v !== null && typeof v === "object" && !Array.isArray(v);
  var hex = (v) => typeof v === "string" && /^[a-f0-9]{16}$/.test(v);
  var canonical = (value) => JSON.stringify(sort(value));
  function sort(value) {
    if (Array.isArray(value)) return value.map(sort);
    return object(value) ? Object.fromEntries(Object.keys(value).sort().map((k) => [k, sort(value[k])])) : value;
  }
  function parseBounded(raw) {
    check(typeof raw === "string" && new TextEncoder().encode(raw).length <= MAX_TEXT_BYTES, "text_envelope_overflow");
    let at = 0;
    const space = () => {
      while (/[\x20\t\r\n]/.test(raw[at] || "\0")) at++;
    };
    const eat = (c) => {
      space();
      if (raw[at] === c) {
        at++;
        return true;
      }
      return false;
    };
    const string = () => {
      space();
      const start = at;
      check(raw[at++] === '"', "text_envelope_invalid");
      while (at < raw.length) {
        const c = raw[at++];
        if (c === "\\") {
          at++;
          continue;
        }
        if (c !== '"') continue;
        const result2 = JSON.parse(raw.slice(start, at));
        for (const ch of result2) {
          const n = ch.codePointAt(0);
          check(n < 55296 || n > 57343, "text_envelope_invalid");
        }
        return result2;
      }
      throw Error("text_envelope_invalid");
    };
    const value = (depth) => {
      check(depth <= 4, "text_envelope_invalid");
      space();
      if (raw[at] === '"') return string();
      if (eat("{")) {
        const entries = [], keys = /* @__PURE__ */ new Set();
        if (eat("}")) return {};
        do {
          const k = string();
          check(!keys.has(k) && eat(":"), "text_envelope_invalid");
          keys.add(k);
          entries.push([k, value(depth + 1)]);
          check(keys.size <= 84, "text_envelope_invalid");
          if (eat("}")) return Object.fromEntries(entries);
        } while (eat(","));
        throw Error("text_envelope_invalid");
      }
      const token = /^(?:true|false|null|-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?)/.exec(raw.slice(at));
      check(token, "text_envelope_invalid");
      at += token[0].length;
      const result2 = JSON.parse(token[0]);
      check(typeof result2 !== "number" || Number.isFinite(result2), "text_envelope_invalid");
      return result2;
    };
    const result = value(0);
    space();
    check(at === raw.length, "text_envelope_invalid");
    return result;
  }
  function parseWireToken(raw) {
    check(typeof raw === "string" && raw.length <= 255, "wire_invalid");
    const [v, token, nonce, pairs, ...rest] = raw.split("|");
    check(v === "2" && !rest.length && hex(token) && hex(nonce) && typeof pairs === "string" && /^(?:[a-f0-9]{4})*$/.test(pairs), "wire_invalid");
    const choices = {};
    let last = -1;
    for (let i = 0; i < pairs.length; i += 4) {
      const k = pairs.slice(i, i + 2);
      check(parseInt(k, 16) > last, "wire_duplicate_or_unsorted_choice");
      last = parseInt(k, 16);
      choices[k] = pairs.slice(i + 2, i + 4);
    }
    return { token, nonce, choices };
  }
  function textRecord(text) {
    check(object(text) && Object.keys(text).length <= 84 && Object.values(text).every((v) => typeof v === "string"), "text_invalid");
    return structuredClone(text);
  }
  function parseTextEnvelope(raw) {
    if (raw == null || raw === "") return { v: 3, b: {} };
    const env = parseBounded(raw);
    check(object(env) && object(env.b) && Object.keys(env.b).length <= MAX_TEXT_RECORDS, "text_envelope_invalid");
    const keys = Object.keys(env).sort().join(",");
    check(env.v === 2 && keys === "b,r,v" && hex(env.r) || env.v === 3 && keys === "b,v", "text_envelope_invalid");
    const b = Object.fromEntries(Object.entries(env.b).map(([n, record]) => {
      check(hex(n), "wire_nonce_invalid");
      if (env.v === 2) return [n, { r: env.r, t: textRecord(record) }];
      check(object(record) && Object.keys(record).sort().join(",") === "r,t" && hex(record.r), "text_envelope_invalid");
      return [n, { r: record.r, t: textRecord(record.t) }];
    }));
    return { v: 3, b };
  }
  function writeTextEnvelope(envelope) {
    const normalized = parseTextEnvelope(JSON.stringify(envelope.v === 3 ? { v: 3, b: envelope.b } : envelope)), records = Object.values(normalized.b);
    const revisions = new Set(records.map((record) => record.r));
    if (revisions.size <= 1) for (const record of records) check(Object.values(record.t).every((value) => value.length <= 1024), "text_v2_field_limit");
    const raw = JSON.stringify(revisions.size > 1 ? normalized : { v: 2, r: records[0]?.r || envelope.r || "0000000000000000", b: Object.fromEntries(Object.entries(normalized.b).map(([nonce, record]) => [nonce, record.t])) });
    check(new TextEncoder().encode(raw).length <= MAX_TEXT_BYTES, "text_envelope_overflow");
    return raw;
  }
  function readWireText(raw, wire) {
    const parsed = typeof wire === "string" ? parseWireToken(wire) : wire;
    const record = parseTextEnvelope(raw).b[parsed.nonce];
    check(record, "text_record_missing");
    check(record.r === parsed.token, "configuration_outdated");
    return record.t;
  }
  function cartRecords(cart) {
    const env = parseTextEnvelope(cart.attributes?.[TEXT_KEY]), records = /* @__PURE__ */ new Map();
    for (const line of cart.items) {
      if (!Object.hasOwn(line.properties || {}, WIRE_KEY)) continue;
      check(!line.parent_relationship?.parent_key, "wire_on_child");
      const parsed = parseWireToken(line.properties[WIRE_KEY]);
      check(!records.has(parsed.nonce), "nonce_collision");
      readWireText(cart.attributes?.[TEXT_KEY], parsed);
      records.set(parsed.nonce, env.b[parsed.nonce]);
    }
    return records;
  }
  function stageTextRecord(raw, token, nonce, text, retainNonces) {
    check(hex(token) && hex(nonce), "wire_invalid");
    const env = parseTextEnvelope(raw), keep = retainNonces == null ? Object.keys(env.b) : retainNonces;
    for (const n of keep) check(env.b[n], "text_record_missing");
    const retained = new Set(keep), b = Object.fromEntries(Object.entries(env.b).filter(([n]) => retained.has(n)));
    const record = { r: token, t: textRecord(text) };
    check(!b[nonce] || canonical(b[nonce]) === canonical(record), "nonce_collision");
    b[nonce] = record;
    return writeTextEnvelope({ v: 3, b });
  }
  function decodeWireSelection(raw, textRaw, dictionary) {
    const parsed = parseWireToken(raw);
    check(parsed.token === dictionary.token, "configuration_outdated");
    const choices = {};
    for (const [k, v] of Object.entries(parsed.choices)) {
      const entry = dictionary.options[parseInt(k, 16)], value = entry?.[1][parseInt(v, 16)];
      check(entry && value !== void 0, "wire_choice_unknown");
      choices[entry[0]] = value;
    }
    return { schemaVersion: 1, revision: dictionary.revision, choices, text: readWireText(textRaw, parsed) };
  }

  // work/final-matrixify-30A/local-ready-30L/latest-binding-review/app/lib/model-utils.mjs
  var canonical2 = (value) => value === null || typeof value !== "object" ? JSON.stringify(value) : Array.isArray(value) ? "[" + value.map(canonical2).join(",") + "]" : "{" + Object.keys(value).sort().map((k) => JSON.stringify(k) + ":" + canonical2(value[k])).join(",") + "}";
  var K = [1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298];
  var rotr = (v, n) => v >>> n | v << 32 - n;
  function sha256(text) {
    const bytes = new TextEncoder().encode(text), length = Math.ceil((bytes.length + 9) / 64) * 64, input = new Uint8Array(length);
    input.set(bytes);
    input[bytes.length] = 128;
    const view = new DataView(input.buffer), bits = bytes.length * 8;
    view.setUint32(length - 8, Math.floor(bits / 4294967296));
    view.setUint32(length - 4, bits >>> 0);
    const h = [1779033703, 3144134277, 1013904242, 2773480762, 1359893119, 2600822924, 528734635, 1541459225], w = new Uint32Array(64);
    for (let i = 0; i < length; i += 64) {
      for (let t = 0; t < 16; t++) w[t] = view.getUint32(i + t * 4);
      for (let t = 16; t < 64; t++) {
        const a2 = w[t - 15], b2 = w[t - 2], s0 = rotr(a2, 7) ^ rotr(a2, 18) ^ a2 >>> 3, s1 = rotr(b2, 17) ^ rotr(b2, 19) ^ b2 >>> 10;
        w[t] = w[t - 16] + s0 + w[t - 7] + s1 >>> 0;
      }
      let [a, b, c, d, e, f, g, z] = h;
      for (let t = 0; t < 64; t++) {
        const s1 = rotr(e, 6) ^ rotr(e, 11) ^ rotr(e, 25), ch = e & f ^ ~e & g, t1 = z + s1 + ch + K[t] + w[t] >>> 0, s0 = rotr(a, 2) ^ rotr(a, 13) ^ rotr(a, 22), maj = a & b ^ a & c ^ b & c, t2 = s0 + maj >>> 0;
        z = g;
        g = f;
        f = e;
        e = d + t1 >>> 0;
        d = c;
        c = b;
        b = a;
        a = t1 + t2 >>> 0;
      }
      for (const [j, v] of [a, b, c, d, e, f, g, z].entries()) h[j] = h[j] + v >>> 0;
    }
    return h.map((n) => n.toString(16).padStart(8, "0")).join("");
  }

  // work/global-launch-options-2026-11-03/mixed-envelope/src/legacy-wire-v2.mjs
  var WIRE_KEY2 = "_ceika_wire_v2";
  var TEXT_KEY2 = "_ceika_text_v2";
  var MAX_TEXT_BYTES2 = 8192;
  var MAX_TEXT_RECORDS2 = 12;
  var obj = (v) => v !== null && typeof v === "object" && !Array.isArray(v);
  var check2 = (b, e) => {
    if (!b) throw Error(e);
  };
  var hex2 = (n) => n.toString(16).padStart(2, "0");
  var cleanKey = (k) => typeof k === "string" && k.length > 0 && k.length <= 120 && !["__proto__", "constructor", "prototype"].includes(k);
  var compactArray = (a) => {
    while (a.length && a.at(-1) === void 0) a.pop();
    return a.map((x) => x === void 0 ? null : x);
  };
  function createWireDictionary(compiled) {
    const keys = /* @__PURE__ */ new Map();
    for (const { policy } of compiled.policies) for (const [k, o] of Object.entries(policy.options || {})) {
      if (!keys.has(k)) keys.set(k, /* @__PURE__ */ new Set());
      for (const v of Object.keys(o.values || {})) keys.get(k).add(v);
    }
    const options = [...keys].sort(([a], [b]) => a.localeCompare(b, "en")).map(([k, v]) => [k, [...v].sort()]);
    check2(options.length < 255 && options.every(([, vs]) => vs.length < 255), "wire_dictionary_too_large");
    const dictionary = { schemaVersion: 2, revision: compiled.release.id, options };
    return { ...dictionary, token: sha256(canonical2(dictionary)).slice(0, 16) };
  }
  function indexes(d) {
    check2(d?.schemaVersion === 2 && /^[a-f0-9]{16}$/.test(d.token) && Array.isArray(d.options), "wire_dictionary_invalid");
    return new Map(d.options.map(([k, vs], i) => [k, { id: hex2(i), values: new Map(vs.map((v, j) => [v, hex2(j)])) }]));
  }
  var nonceForBuild = (buildId) => {
    check2(/^[A-Za-z0-9-]{8,80}$/.test(buildId || ""), "invalid_build_id");
    return sha256(buildId).slice(0, 16);
  };
  function encodeWireSelection(selection, d, nonce) {
    check2(/^[a-f0-9]{16}$/.test(nonce), "wire_nonce_invalid");
    check2(selection?.revision === d.revision && obj(selection.choices), "configuration_outdated");
    const index = indexes(d), pairs = [];
    for (const [k, v] of Object.entries(selection.choices)) {
      const o = index.get(k);
      check2(o && o.values.has(v), "wire_choice_unknown");
      pairs.push(o.id + o.values.get(v));
    }
    pairs.sort();
    const wire = "2|" + d.token + "|" + nonce + "|" + pairs.join("");
    check2(wire.length <= 255, "wire_selection_too_large");
    return wire;
  }
  function parseWireToken2(raw) {
    check2(typeof raw === "string" && raw.length <= 255 && /^[\x20-\x7e]*$/.test(raw), "wire_invalid");
    const [v, token, nonce, pairs, ...rest] = raw.split("|");
    check2(v === "2" && !rest.length && /^[a-f0-9]{16}$/.test(token) && /^[a-f0-9]{16}$/.test(nonce) && /^(?:[a-f0-9]{4})*$/.test(pairs), "wire_invalid");
    const choices = {};
    let last = -1;
    for (let i = 0; i < pairs.length; i += 4) {
      const k = pairs.slice(i, i + 2), n = parseInt(k, 16);
      check2(n > last, "wire_duplicate_or_unsorted_choice");
      last = n;
      choices[k] = pairs.slice(i + 2, i + 4);
    }
    return { token, nonce, choices };
  }
  function textRecord2(text) {
    check2(obj(text) && Object.keys(text).length <= 40, "text_invalid");
    for (const [k, v] of Object.entries(text)) check2(cleanKey(k) && typeof v === "string" && v.length <= 1024, "text_invalid");
    return structuredClone(text);
  }
  function stageTextRecord2(raw, token, nonce, text, retainNonces) {
    return stageTextRecord(raw, token, nonce, textRecord2(text), retainNonces);
  }
  function decodeWireSelection2(raw, textRaw, d) {
    const selection = decodeWireSelection(raw, textRaw, d);
    selection.text = textRecord2(selection.text);
    return selection;
  }
  function compileWirePolicy(source, d) {
    const index = indexes(d), key = (k) => {
      check2(index.has(k), "wire_rule_key_unknown");
      return index.get(k).id;
    }, value = (k, v) => {
      check2(index.get(k)?.values.has(v), "wire_rule_value_unknown");
      return index.get(k).values.get(v);
    };
    const when = (w) => w == null ? void 0 : Object.fromEntries(Object.entries(w).map(([k, vs]) => [key(k), vs.map((v) => value(k, v))]));
    const ids = [];
    const charges = (list) => (list || []).map((c) => {
      check2(/^gid:\/\/shopify\/ProductVariant\/[0-9]+$/.test(c.variantId), "wire_charge_id_invalid");
      const suffix = c.variantId.slice("gid://shopify/ProductVariant/".length);
      let i = ids.indexOf(suffix);
      if (i < 0) {
        i = ids.length;
        ids.push(suffix);
      }
      return compactArray([i, c.units, when(c.when)]);
    });
    check2(["base", "test-exclusive-charge"].includes(source.kind), "wire_policy_kind_invalid");
    if (source.kind === "test-exclusive-charge") return { v: 2, k: 1, p: source.productId, purchaseEnabled: false };
    const p = { v: 2, k: source.kind === "base" ? 0 : 1, e: source.enabled, purchaseEnabled: source.purchaseEnabled ?? false, r: d.token, p: source.productId, i: source.variantId };
    if (source.kind !== "base" || source.enabled !== true) return p;
    const o = {};
    for (const [k, opt] of Object.entries(source.options || {})) {
      const vs = {};
      for (const [v, def] of Object.entries(opt.values)) {
        const cs = charges(def.charges);
        vs[value(k, v)] = compactArray([cs.length ? cs : void 0, when(def.when), def.whenAny?.map(when)]);
      }
      o[key(k)] = compactArray([opt.required === true, vs, when(opt.when), opt.lockedValue === void 0 ? void 0 : value(k, opt.lockedValue)]);
    }
    p.o = o;
    const mandatory = charges(source.mandatoryCharges);
    if (mandatory.length) p.m = mandatory;
    if (ids.length) p.d = ids;
    if (Object.keys(source.textFields || {}).length) p.t = Object.fromEntries(Object.entries(source.textFields).map(([k, f]) => [k, { ...f, ...f.when ? { when: when(f.when) } : {} }]));
    if (source.forbiddenCombinations?.length) p.f = source.forbiddenCombinations.map(when);
    if (source.clearanceRules) {
      const c = source.clearanceRules;
      p.c = [key(c.wheelKey), key(c.acknowledgementKey), value(c.acknowledgementKey, "acknowledged"), Object.fromEntries(d.options[parseInt(key(c.wheelKey), 16)][1].map((v, i) => [hex2(i), Number(v)])), c.branches.map((b) => compactArray([b.minimumNominal, when(b.when)]))];
    }
    return p;
  }
  function expandWirePolicy(p, d, ownerId) {
    check2(p?.v === 2 && (p.k === 1 || p.r === d.token), "wire_policy_version");
    if (p.k === 1) {
      check2(/^gid:\/\/shopify\/ProductVariant\/\d+$/.test(ownerId || ""), "wire_policy_owner_missing");
      return { schemaVersion: 1, kind: "test-exclusive-charge", enabled: true, purchaseEnabled: p.purchaseEnabled, revision: d.revision, productId: p.p, variantId: ownerId };
    }
    const key = (id) => {
      const o = d.options[parseInt(id, 16)];
      check2(o, "wire_rule_key_unknown");
      return o[0];
    };
    const value = (id, v) => {
      const o = d.options[parseInt(id, 16)], s = o?.[1][parseInt(v, 16)];
      check2(s !== void 0, "wire_rule_value_unknown");
      return s;
    };
    const when = (w) => w == null ? void 0 : Object.fromEntries(Object.entries(w).map(([k, vs]) => [key(k), vs.map((v) => value(k, v))]));
    const charges = (cs) => (cs || []).map(([i, units, w]) => {
      check2(typeof p.d?.[i] === "string" && /^[0-9]+$/.test(p.d[i]), "wire_charge_id_invalid");
      return { variantId: "gid://shopify/ProductVariant/" + p.d[i], units, ...w ? { when: when(w) } : {} };
    });
    const full = { schemaVersion: 1, kind: p.k === 0 ? "base" : "test-exclusive-charge", enabled: p.e, purchaseEnabled: p.purchaseEnabled, revision: d.revision, productId: p.p, variantId: p.i };
    if (p.k !== 0 || p.e !== true) return full;
    full.options = Object.fromEntries(Object.entries(p.o).map(([k, [required, values, w, locked]]) => [key(k), { required, values: Object.fromEntries(Object.entries(values).map(([v, [cs, vw, any]]) => [value(k, v), { charges: charges(cs), ...vw ? { when: when(vw) } : {}, ...any ? { whenAny: any.map(when) } : {} }])), ...w ? { when: when(w) } : {}, ...locked != null ? { lockedValue: value(k, locked) } : {} }]));
    full.mandatoryCharges = charges(p.m);
    full.forbiddenCombinations = (p.f || []).map(when);
    full.textFields = Object.fromEntries(Object.entries(p.t || {}).map(([k, f]) => [k, { ...f, ...f.when ? { when: when(f.when) } : {} }]));
    if (p.c) {
      const [w, a, , , branches] = p.c;
      full.clearanceRules = { wheelKey: key(w), acknowledgementKey: key(a), branches: branches.map(([minimumNominal, condition]) => ({ minimumNominal, ...condition ? { when: when(condition) } : {} })) };
    }
    return full;
  }

  // work/global-launch-options-2026-11-03/mixed-envelope/src/active-cart-records.mjs
  function activeCartRecords(cart) {
    if (!cart.items.some((line) => Object.hasOwn(line.properties || {}, WIRE_KEY))) return /* @__PURE__ */ new Map();
    return cartRecords(cart);
  }

  // work/global-launch-options-2026-11-03/mixed-envelope/src/bbk-entry.mjs
  (function(global) {
    "use strict";
    const SELECTION_SCHEMA_VERSION = 1;
    const PROPERTY_PREFIX = "_ceika_selection";
    const CHUNK_LENGTH = 255;
    const MAX_CHUNKS = 16;
    const object2 = (value) => value && typeof value === "object" && !Array.isArray(value);
    const check3 = (condition, code) => {
      if (!condition) throw new Error(code);
    };
    const unsafe = (key) => ["__proto__", "constructor", "prototype"].includes(key);
    function canonicalSelection({ revision, choices, text = {} }) {
      check3(typeof revision === "string" && revision.length > 0 && revision.length <= 120, "revision_invalid");
      check3(object2(choices) && Object.keys(choices).length <= 80, "choices_invalid");
      check3(object2(text) && Object.keys(text).length <= 40, "text_invalid");
      for (const [key, value] of Object.entries(choices)) {
        check3(key.length > 0 && key.length <= 120 && !unsafe(key), "choice_key_invalid");
        check3(typeof value === "string" && value.length > 0 && value.length <= 120, "choice_value_invalid");
      }
      for (const [key, value] of Object.entries(text)) {
        check3(key.length > 0 && key.length <= 120 && !unsafe(key), "text_key_invalid");
        check3(typeof value === "string" && value.length <= 1024, "text_value_invalid");
      }
      const ordered = (record) => Object.fromEntries(Object.keys(record).sort().map((key) => [key, record[key]]));
      return { schemaVersion: SELECTION_SCHEMA_VERSION, revision, choices: ordered(choices), text: ordered(text) };
    }
    function selectionProperties(selection) {
      const normalized = canonicalSelection(selection);
      const points = Array.from(JSON.stringify(normalized));
      const chunks = [];
      let chunk = "";
      for (const point of points) {
        if (chunk.length + point.length > CHUNK_LENGTH) {
          chunks.push(chunk);
          chunk = "";
        }
        chunk += point;
      }
      if (chunk) chunks.push(chunk);
      check3(chunks.length <= MAX_CHUNKS, "selection_too_long");
      return Object.fromEntries(chunks.map((value, index) => [index ? `${PROPERTY_PREFIX}_${index}` : PROPERTY_PREFIX, value]));
    }
    function selectionFromProperties(properties) {
      check3(object2(properties), "selection_missing");
      let raw = "", ended = false;
      for (let index = 0; index < MAX_CHUNKS; index++) {
        const value = properties[index ? `${PROPERTY_PREFIX}_${index}` : PROPERTY_PREFIX];
        if (value == null || value === "") {
          ended = true;
          continue;
        }
        check3(!ended && typeof value === "string" && value.length <= CHUNK_LENGTH, "selection_invalid");
        raw += value;
      }
      check3(raw.length > 0, "selection_missing");
      let selection;
      try {
        selection = JSON.parse(raw);
      } catch {
        throw new Error("selection_invalid");
      }
      check3(selection.schemaVersion === SELECTION_SCHEMA_VERSION, "selection_schema_invalid");
      check3(Object.keys(selection).every((key) => ["schemaVersion", "revision", "choices", "text"].includes(key)), "selection_invalid");
      return canonicalSelection(selection);
    }
    function replaceSelectionProperties(properties, selection) {
      const next = Object.fromEntries(Object.entries(properties || {}).filter(([key]) => !/^_ceika_selection(?:_\d+)?$/.test(key)));
      return { ...next, ...selectionProperties(selection) };
    }
    function selectionFunctionAttributes(properties) {
      return Object.fromEntries(Array.from({ length: MAX_CHUNKS }, (_, index) => {
        const key = index ? `${PROPERTY_PREFIX}_${index}` : PROPERTY_PREFIX;
        return [index ? `selection${index}` : "selection", properties[key] ? { value: properties[key] } : null];
      }));
    }
    global.CeikaCanonicalSelection = { selectionProperties, selectionFromProperties, replaceSelectionProperties };
  })(typeof window !== "undefined" ? window : globalThis);
  (function(global) {
    "use strict";
    const canonical3 = (value) => value === null || typeof value !== "object" ? JSON.stringify(value) : Array.isArray(value) ? "[" + value.map(canonical3).join(",") + "]" : "{" + Object.keys(value).sort().map((k) => JSON.stringify(k) + ":" + canonical3(value[k])).join(",") + "}";
    const K2 = [1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298];
    const rotr2 = (v, n) => v >>> n | v << 32 - n;
    function sha2562(text) {
      const bytes = new TextEncoder().encode(text), length = Math.ceil((bytes.length + 9) / 64) * 64, input = new Uint8Array(length);
      input.set(bytes);
      input[bytes.length] = 128;
      const view = new DataView(input.buffer), bits = bytes.length * 8;
      view.setUint32(length - 8, Math.floor(bits / 4294967296));
      view.setUint32(length - 4, bits >>> 0);
      const h = [1779033703, 3144134277, 1013904242, 2773480762, 1359893119, 2600822924, 528734635, 1541459225], w = new Uint32Array(64);
      for (let i = 0; i < length; i += 64) {
        for (let t = 0; t < 16; t++) w[t] = view.getUint32(i + t * 4);
        for (let t = 16; t < 64; t++) {
          const a2 = w[t - 15], b2 = w[t - 2], s0 = rotr2(a2, 7) ^ rotr2(a2, 18) ^ a2 >>> 3, s1 = rotr2(b2, 17) ^ rotr2(b2, 19) ^ b2 >>> 10;
          w[t] = w[t - 16] + s0 + w[t - 7] + s1 >>> 0;
        }
        let [a, b, c, d, e, f, g, z] = h;
        for (let t = 0; t < 64; t++) {
          const s1 = rotr2(e, 6) ^ rotr2(e, 11) ^ rotr2(e, 25), ch = e & f ^ ~e & g, t1 = z + s1 + ch + K2[t] + w[t] >>> 0, s0 = rotr2(a, 2) ^ rotr2(a, 13) ^ rotr2(a, 22), maj = a & b ^ a & c ^ b & c, t2 = s0 + maj >>> 0;
          z = g;
          g = f;
          f = e;
          e = d + t1 >>> 0;
          d = c;
          c = b;
          b = a;
          a = t1 + t2 >>> 0;
        }
        for (const [j, v] of [a, b, c, d, e, f, g, z].entries()) h[j] = h[j] + v >>> 0;
      }
      return h.map((n) => n.toString(16).padStart(8, "0")).join("");
    }
    const digest = (value) => sha2562(canonical3(value));
    const WIRE_KEY3 = "_ceika_wire_v2";
    const TEXT_KEY3 = "_ceika_text_v2";
    const MAX_TEXT_BYTES3 = 8192;
    const MAX_TEXT_RECORDS3 = 12;
    const obj2 = (v) => v !== null && typeof v === "object" && !Array.isArray(v);
    const own = (o, k) => Object.prototype.hasOwnProperty.call(o, k);
    const check3 = (b, e) => {
      if (!b) throw Error(e);
    };
    const hex3 = (n) => n.toString(16).padStart(2, "0");
    const size = (s) => new TextEncoder().encode(s).length;
    const cleanKey2 = (k) => typeof k === "string" && k.length > 0 && k.length <= 120 && !["__proto__", "constructor", "prototype"].includes(k);
    const compactArray2 = (a) => {
      while (a.length && a.at(-1) === void 0) a.pop();
      return a.map((x) => x === void 0 ? null : x);
    };
    function createWireDictionary2(compiled) {
      const keys = /* @__PURE__ */ new Map();
      for (const { policy } of compiled.policies) for (const [k, o] of Object.entries(policy.options || {})) {
        if (!keys.has(k)) keys.set(k, /* @__PURE__ */ new Set());
        for (const v of Object.keys(o.values || {})) keys.get(k).add(v);
      }
      const options = [...keys].sort(([a], [b]) => a.localeCompare(b, "en")).map(([k, v]) => [k, [...v].sort()]);
      check3(options.length < 255 && options.every(([, vs]) => vs.length < 255), "wire_dictionary_too_large");
      const dictionary = { schemaVersion: 2, revision: compiled.release.id, options };
      return { ...dictionary, token: sha2562(canonical3(dictionary)).slice(0, 16) };
    }
    function indexes2(d) {
      check3(d?.schemaVersion === 2 && /^[a-f0-9]{16}$/.test(d.token) && Array.isArray(d.options), "wire_dictionary_invalid");
      return new Map(d.options.map(([k, vs], i) => [k, { id: hex3(i), values: new Map(vs.map((v, j) => [v, hex3(j)])) }]));
    }
    const nonceForBuild2 = (buildId) => {
      check3(/^[A-Za-z0-9-]{8,80}$/.test(buildId || ""), "invalid_build_id");
      return sha2562(buildId).slice(0, 16);
    };
    function encodeWireSelection2(selection, d, nonce) {
      check3(/^[a-f0-9]{16}$/.test(nonce), "wire_nonce_invalid");
      check3(selection?.revision === d.revision && obj2(selection.choices), "configuration_outdated");
      const index = indexes2(d), pairs = [];
      for (const [k, v] of Object.entries(selection.choices)) {
        const o = index.get(k);
        check3(o && o.values.has(v), "wire_choice_unknown");
        pairs.push(o.id + o.values.get(v));
      }
      pairs.sort();
      const wire = "2|" + d.token + "|" + nonce + "|" + pairs.join("");
      check3(wire.length <= 255, "wire_selection_too_large");
      return wire;
    }
    function parseWireToken3(raw) {
      check3(typeof raw === "string" && raw.length <= 255 && /^[\x20-\x7e]*$/.test(raw), "wire_invalid");
      const [v, token, nonce, pairs, ...rest] = raw.split("|");
      check3(v === "2" && !rest.length && /^[a-f0-9]{16}$/.test(token) && /^[a-f0-9]{16}$/.test(nonce) && /^(?:[a-f0-9]{4})*$/.test(pairs), "wire_invalid");
      const choices = {};
      let last = -1;
      for (let i = 0; i < pairs.length; i += 4) {
        const k = pairs.slice(i, i + 2), n = parseInt(k, 16);
        check3(n > last, "wire_duplicate_or_unsorted_choice");
        last = n;
        choices[k] = pairs.slice(i + 2, i + 4);
      }
      return { token, nonce, choices };
    }
    function textRecord3(text) {
      check3(obj2(text) && Object.keys(text).length <= 40, "text_invalid");
      for (const [k, v] of Object.entries(text)) check3(cleanKey2(k) && typeof v === "string" && v.length <= 1024, "text_invalid");
      return structuredClone(text);
    }
    const { parseTextEnvelope: parseTextEnvelope2, writeTextEnvelope: writeTextEnvelope2, stageTextRecord: stageTextRecord3, decodeWireSelection: decodeWireSelection3 } = legacy_wire_v2_exports;
    global.CeikaWireV2 = { WIRE_KEY: WIRE_KEY3, TEXT_KEY: TEXT_KEY3, canonical: canonical3, nonceForBuild: nonceForBuild2, encodeWireSelection: encodeWireSelection2, parseWireToken: parseWireToken3, parseTextEnvelope: parseTextEnvelope2, writeTextEnvelope: writeTextEnvelope2, stageTextRecord: stageTextRecord3, decodeWireSelection: decodeWireSelection3, dictionary: { "schemaVersion": 2, "revision": "27-HARDWARE-REAR", "options": [["_clearance", ["acknowledged"]], ["_parking", ["not-applicable", "with", "without"]], ["_wheel", ["15", "16", "17", "18", "19", "20", "21", "22"]], ["boots-both", ["external-flexible-dust-boots-for-extreme-weather", "internal-dust-scrappers-seals-protecting-oil-seals"]], ["boots-single", ["external-flexible-dust-boots-for-extreme-weather", "internal-dust-scrappers-seals-protecting-oil-seals"]], ["clearcoat-both", ["gloss-clear-coat", "without-clear-coat"]], ["clearcoat-single", ["gloss-clear-coat", "without-clear-coat"]], ["coating-both", ["black-anti-corrosion-coating-front-rear", "no-coating", "silver-anti-corrosion-coating-front-rear"]], ["coating-single", ["black-anti-corrosion-coating", "no-coating", "silver-anti-corrosion-coating"]], ["color-anodized", ["anodized-black", "anodized-bronze", "anodized-brown", "anodized-champagne-gold", "anodized-dark-red", "anodized-deep-blue", "anodized-flashy-blue", "anodized-gold", "anodized-green", "anodized-iron-grey", "anodized-light-blue", "anodized-orange", "anodized-orange-yellow", "anodized-purple", "anodized-silver"]], ["color-gloss", ["gloss-painted-black", "gloss-painted-dark-blue", "gloss-painted-dark-grey", "gloss-painted-flashy-blue", "gloss-painted-fluo-green", "gloss-painted-fluo-turquoise", "gloss-painted-gold", "gloss-painted-light-blue", "gloss-painted-orange", "gloss-painted-orange-yellow", "gloss-painted-purple", "gloss-painted-red", "gloss-painted-white", "gloss-painted-yellow"]], ["finish-both", ["anodized-anti-corrosion-color-front-rear", "custom-gloss-painted-mix-front-rear", "gloss-painted-color-with-anti-corrosion-pre-coat-front-rear", "hard-extra-tough-anodized-front-rear", "raw-extra-milled-polished-front-rear"]], ["finish-hard-detail", ["hard-anodized-black"]], ["finish-raw-detail", ["raw-extra-milled-polished-calipers"]], ["finish-single", ["anodized-anti-corrosion-color", "custom-gloss-painted-mix", "gloss-painted-color-with-anti-corrosion-pre-coat", "hard-extra-tough-anodized", "raw-extra-milled-polished"]], ["floating-both", ["standard-2-pcs-alloy"]], ["floating-single", ["standard-2-pcs-alloy"]], ["hat-color", ["anodized-black", "anodized-bronze", "anodized-brown", "anodized-champagne-gold", "anodized-dark-red", "anodized-deep-blue", "anodized-flashy-blue", "anodized-gold", "anodized-green", "anodized-iron-grey", "anodized-light-blue", "anodized-orange", "anodized-orange-yellow", "anodized-purple", "anodized-silver", "raw-polised-alloy"]], ["logo-color", ["gloss-painted-black", "gloss-painted-dark-blue", "gloss-painted-dark-grey", "gloss-painted-flashy-blue", "gloss-painted-fluo-green", "gloss-painted-fluo-turquoise", "gloss-painted-gold", "gloss-painted-light-blue", "gloss-painted-orange", "gloss-painted-orange-yellow", "gloss-painted-purple", "gloss-painted-red", "gloss-painted-white", "gloss-painted-yellow", "raw-alloy"]], ["pads-front", ["pro-race", "race", "sport", "street"]], ["pads-rear", ["pro-race", "race", "sport", "street"]], ["pads-single", ["pro-race", "race", "sport", "street"]], ["pistons-front", ["stainless-steel-pistons", "standard-aluminium-pistons", "vented-aluminium-pistons", "vented-stainless-steel-pistons"]], ["pistons-rear", ["stainless-steel-pistons", "standard-aluminium-pistons", "vented-aluminium-pistons", "vented-stainless-steel-pistons"]], ["pistons-single", ["stainless-steel-pistons", "standard-aluminium-pistons", "vented-aluminium-pistons", "vented-stainless-steel-pistons"]], ["springs-front", ["add", "do-not-add"]], ["springs-rear", ["add", "do-not-add"]], ["springs-single", ["add", "do-not-add"]], ["surface", ["drilled-and-curved-slots", "drilled-and-straight-slots", "drilled-only", "slotted-only"]], ["wave-both", ["do-not-add"]], ["wave-single", ["do-not-add"]]], "token": "0a722ac6c7739971" } };
  })(typeof window !== "undefined" ? window : globalThis);
  (function(global) {
    "use strict";
    const assert = (condition, code) => {
      if (!condition) throw new Error(code);
    };
    function normalizeRoot(root) {
      assert(typeof root === "string" && /^\/(?:[a-z0-9]+(?:-[a-z0-9]+)*\/)*[a-z0-9]*(?:-[a-z0-9]+)*$/i.test(root), "invalid_route");
      return root.endsWith("/") ? root : root + "/";
    }
    const id = (value) => String(value).split("/").at(-1);
    const savedUpload = (value) => typeof value === "string" && /^https:\/\/cdn\.shopify\.com\/s\/files\/1\/0077\/2099\/2832\/uploads\/[A-Za-z0-9_.%-]+$/.test(value);
    const propsEqual = (actual, expected) => Object.entries(expected).every(([key, value]) => String(actual?.[key] ?? "") === String(value));
    const wireAPI = global.CeikaWireV2;
    const wireDictionary = wireAPI.dictionary;
    const wireParents = (cart) => cart.items.filter((line) => typeof line.properties?.[wireAPI.WIRE_KEY] === "string" && !line.parent_relationship?.parent_key);
    function resolveBoundDictionary(catalog, config) {
      const binding = catalog.productionBindings, connection = config.connection;
      assert(binding?.status === "VERIFIED_READBACK_LOCKED" && binding.productId === String(catalog.productId), "binding_product_mismatch");
      assert(connection?.family === "bbk" && connection.productId === String(catalog.productId) && config.productId === String(catalog.productId), "binding_product_mismatch");
      const dictionary = connection.dictionary;
      assert(dictionary?.schemaVersion === 2 && /^[a-f0-9]{16}$/.test(dictionary.token) && Array.isArray(dictionary.options) && binding.dictionary?.token === dictionary.token, "configuration_outdated");
      binding.dictionary = dictionary;
      return catalog;
    }
    function configureWireDictionary(catalog) {
      const binding = catalog.productionBindings;
      if (!binding) return;
      assert(binding.status === "VERIFIED_READBACK_LOCKED" && binding.productId === String(catalog.productId), "binding_product_mismatch");
      assert(binding.dictionary?.schemaVersion === 2 && /^[a-f0-9]{16}$/.test(binding.dictionary.token), "configuration_outdated");
      Object.assign(wireDictionary, binding.dictionary);
    }
    const wireLineSignature = (cart) => JSON.stringify(cart.items.map((line) => ({ key: line.key, id: id(line.variant_id || line.id), quantity: line.quantity, parent: line.parent_relationship?.parent_key || "", properties: line.properties })).sort((a, b) => a.key.localeCompare(b.key)));
    function wireNonces(cart) {
      return [...activeCartRecords(cart).keys()];
    }
    function verifyWireCart(cart, plan) {
      assert(plan.wireData && plan.wireData.token === wireDictionary.token, "configuration_outdated");
      const parent = cart.items.find((line) => line.properties?._ceika_build === plan.buildId && line.properties?._ceika_role === "kit");
      assert(parent && String(parent.product_id) === plan.productId, "wrong_test_product");
      const selection = wireAPI.decodeWireSelection(parent.properties?.[wireAPI.WIRE_KEY], cart.attributes?.[wireAPI.TEXT_KEY], wireDictionary);
      assert(wireAPI.canonical(selection.text) === wireAPI.canonical(plan.wireData.text), "configuration_text_changed");
      assert(parent.properties[wireAPI.WIRE_KEY] === plan.wireData.wire, "configuration_changed");
    }
    async function writeWireEnvelope(transport, before, raw) {
      const key = wireAPI.TEXT_KEY;
      if (before.attributes?.[key] === raw) return before;
      const response = await transport.json("cart/update.js", { method: "POST", body: JSON.stringify({ attributes: { [key]: raw } }) });
      assert(response.attributes?.[key] === raw, "cart_text_not_saved");
      assert(response.currency === before.currency, "currency_changed");
      assert(wireLineSignature(response) === wireLineSignature(before), "cart_changed");
      for (const [name, value] of Object.entries(before.attributes || {})) if (name !== key) assert(response.attributes?.[name] === value, "cart_attributes_changed");
      return response;
    }
    function assertWireTextRetained(before, after) {
      if (!wireParents(before).length) return;
      const old = wireAPI.parseTextEnvelope(before.attributes?.[wireAPI.TEXT_KEY], wireDictionary.token), next = wireAPI.parseTextEnvelope(after.attributes?.[wireAPI.TEXT_KEY], wireDictionary.token);
      for (const nonce of wireNonces(before)) assert(wireAPI.canonical(old.b[nonce]) === wireAPI.canonical(next.b[nonce]), "configuration_text_changed");
    }
    async function stageWireEnvelope(transport, cart, plan) {
      assert(plan.wireData && plan.wireData.token === wireDictionary.token, "configuration_outdated");
      const nonces = wireNonces(cart);
      const previousRaw = nonces.length ? cart.attributes?.[wireAPI.TEXT_KEY] : "";
      const existing = wireAPI.parseTextEnvelope(previousRaw, wireDictionary.token);
      assert(nonces.every((nonce) => Object.prototype.hasOwnProperty.call(existing.b, nonce)), "wire_text_missing");
      assert(!nonces.includes(plan.wireData.nonce), "configuration_nonce_collision");
      assert(nonces.length < (transport.editBusy ? 7 : 6), "configuration_capacity");
      const raw = wireAPI.stageTextRecord(previousRaw, wireDictionary.token, plan.wireData.nonce, plan.wireData.text, nonces);
      return writeWireEnvelope(transport, cart, raw);
    }
    async function pruneWireEnvelope(transport, cart) {
      const envelope = wireAPI.parseTextEnvelope(cart.attributes?.[wireAPI.TEXT_KEY], wireDictionary.token), keep = new Set(wireNonces(cart));
      const raw = wireAPI.writeTextEnvelope({ ...envelope, b: Object.fromEntries(Object.entries(envelope.b).filter(([nonce]) => keep.has(nonce))) });
      return writeWireEnvelope(transport, cart, raw);
    }
    const priceKeys = (catalog) => [.../* @__PURE__ */ new Set([
      ...catalog.baseVariants.map((v) => String(v.id)),
      ...catalog.options.flatMap((o) => o.values.filter((v) => v.chargeVariantId).map((v) => String(v.chargeVariantId))),
      ...Object.values(catalog.upgradePricing?.charges || {}).flatMap((category) => Object.values(category).map((charge) => String(charge.id))),
      ...catalog.parking?.chargeVariantId ? [String(catalog.parking.chargeVariantId)] : []
    ])];
    const validPrice = (value) => Number.isSafeInteger(value?.price) && value.price >= 0;
    function applyPrices(catalog, feed) {
      assert(feed && /^[A-Z]{3}$/.test(feed.currency), "storefront_prices_missing");
      assert(priceKeys(catalog).every((key) => validPrice(feed.variants?.[key])), "storefront_prices_missing");
      const price = (variantId) => feed.variants[String(variantId)].price;
      catalog.baseVariants.forEach((variant) => {
        variant.price = price(variant.id);
      });
      catalog.options.forEach((option) => option.values.forEach((value) => {
        if (value.chargeVariantId) value.price = price(value.chargeVariantId);
      }));
      catalog.parking.price = catalog.parking.chargeVariantId ? price(catalog.parking.chargeVariantId) : 0;
      catalog.currency = feed.currency;
      catalog.currentMarketPrices = feed.variants;
      catalog.priceCountry = feed.country;
      return catalog;
    }
    function applyCataloguePreviewPrices(catalog, config, snapshot, feed) {
      const checked = global.CeikaCatalogueContract.validateSnapshot({ catalog, config, snapshot, feed, context: { shop: global.Shopify?.shop, themeId: global.Shopify?.theme?.id, themeRole: global.Shopify?.theme?.role, designMode: global.Shopify?.designMode === true } });
      return applyPrices(catalog, checked);
    }
    function applySavedDesignPrices(catalog, config, context = { shop: global.Shopify?.shop, themeId: global.Shopify?.theme?.id, themeRole: global.Shopify?.theme?.role, designMode: global.Shopify?.designMode === true }) {
      const preview = catalog.draftDesignReview;
      assert(preview?.enabled === true && config.draftDesignReview === true && catalog.checkoutEnabled === false, "design_review_not_enabled");
      assert(String(catalog.productId) === "15380807745764" && String(config.productId) === catalog.productId, "wrong_test_product");
      assert(config.approvedShop === "ceika-performance-store.myshopify.com" && context.shop === config.approvedShop, "wrong_test_store");
      assert(config.designMode === true && context.designMode === true, "design_review_requires_editor");
      assert(preview.currency === "USD" && catalog.currency === "USD" && /^\d{4}-\d{2}-\d{2}$/.test(preview.priceSnapshotDate), "invalid_design_prices");
      const variants = {};
      const add = (key, price) => {
        assert(/^\d+$/.test(String(key)) && Number.isSafeInteger(price) && price >= 0, "invalid_design_prices");
        variants[String(key)] = { price };
      };
      catalog.baseVariants.forEach((value) => add(value.id, value.price));
      catalog.options.forEach((option) => option.values.forEach((value) => {
        if (value.chargeVariantId) add(value.chargeVariantId, value.price);
      }));
      if (catalog.parking.chargeVariantId) add(catalog.parking.chargeVariantId, catalog.parking.price);
      Object.values(catalog.upgradePricing?.charges || {}).forEach((category) => Object.entries(category).forEach(([amount, charge]) => {
        assert(charge.verified === true, "invalid_design_prices");
        add(charge.id, Number(amount));
      }));
      applyPrices(catalog, { currency: "USD", country: "", variants });
      catalog.priceSource = "saved-design-data";
      return catalog;
    }
    async function loadPrices(catalog, initial, manifest, { root = "/", signal, request = global.fetch?.bind(global) } = {}) {
      assert(catalog.draftDesignReview?.enabled !== true && catalog.priceSource !== "saved-design-data", "checkout_not_enabled");
      root = normalizeRoot(root);
      assert(Array.isArray(manifest) && manifest.length <= 20, "invalid_price_products");
      assert(manifest.every((p) => /^\d+$/.test(p.id) && /^[a-z0-9-]+$/.test(p.handle) && Array.isArray(p.variants)), "invalid_price_products");
      const required = priceKeys(catalog);
      assert(initial?.contextAligned !== false, "market_changed");
      assert(required.every((key) => manifest.some((p) => p.variants.includes(key))), "unknown_price_product");
      const aborted = () => {
        if (signal?.aborted) throw new DOMException("Price loading cancelled", "AbortError");
      };
      let feed = { currency: initial?.currency, country: initial?.country, variants: { ...initial?.variants } };
      const currentCurrency = global.Shopify?.currency?.active;
      const currentCountry = global.Shopify?.designMode === true && global.Shopify?.theme?.role === "unpublished" ? initial?.country : global.Shopify?.country;
      const currencyMismatch = currentCurrency && currentCurrency !== feed.currency;
      const countryMismatch = currentCountry && currentCountry !== feed.country;
      if (currencyMismatch || countryMismatch) feed.variants = {};
      if (/^[A-Z]{3}$/.test(feed.currency) && !currencyMismatch && !countryMismatch && required.every((key) => validPrice(feed.variants[key]))) {
        aborted();
        applyPrices(catalog, feed);
        catalog.priceSource = "shopify_market_liquid";
        return catalog;
      }
      assert(typeof request === "function", "storefront_prices_missing");
      async function read(path) {
        aborted();
        const controller = new AbortController();
        const cancel = () => controller.abort();
        signal?.addEventListener("abort", cancel, { once: true });
        const timer = setTimeout(cancel, 15e3);
        try {
          const response = await request(root + path, { credentials: "same-origin", cache: "no-store", headers: { Accept: "application/json" }, signal: controller.signal });
          assert(response.ok, "storefront_price_request_failed");
          return await response.json();
        } finally {
          clearTimeout(timer);
          signal?.removeEventListener("abort", cancel);
        }
      }
      const cart = await read("cart.js");
      assert(/^[A-Z]{3}$/.test(cart.currency), "storefront_prices_missing");
      assert(!currentCurrency || cart.currency === currentCurrency, "currency_changed");
      if (cart.currency !== feed.currency) feed.variants = {};
      feed.currency = cart.currency;
      feed.country = currentCountry || feed.country || "";
      const missingProducts = manifest.filter((p) => p.variants.some((key) => required.includes(key) && !validPrice(feed.variants[key])));
      let next = 0;
      await Promise.all(Array.from({ length: Math.min(4, missingProducts.length) }, async () => {
        while (next < missingProducts.length) {
          const product = missingProducts[next++];
          let data;
          try {
            data = await read("products/" + product.handle + ".js");
          } catch (error) {
            if (signal?.aborted || !global.CeikaDraftNativePrices?.canRead(product.id)) throw error;
            data = await global.CeikaDraftNativePrices.read({ productId: product.id, currency: feed.currency, country: feed.country, root, request, signal });
          }
          assert(String(data.id) === product.id && Array.isArray(data.variants), "wrong_price_product");
          assert(!data.currency || data.currency === feed.currency, "currency_changed");
          for (const variant of data.variants) {
            if (product.variants.includes(String(variant.id)) && validPrice(variant)) {
              feed.variants[String(variant.id)] = { price: variant.price, available: variant.available };
            }
          }
        }
      }));
      const after = await read("cart.js");
      assert(after.currency === feed.currency, "currency_changed");
      assert(global.Shopify?.designMode === true || !currentCountry || !global.Shopify?.country || currentCountry === global.Shopify.country, "market_changed");
      aborted();
      applyPrices(catalog, feed);
      catalog.priceSource = "shopify_market_ajax";
      return catalog;
    }
    function prepare(engine, { quantity = 1, buildId, wheel, fitment } = {}) {
      configureWireDictionary(engine.catalog);
      assert(engine.catalog.checkoutEnabled === true && engine.catalog.draftDesignReview?.enabled !== true && engine.catalog.priceSource !== "saved-design-data", "checkout_not_enabled");
      assert(engine.catalog.productionBindings?.productId === String(engine.catalog.productId) && engine.catalog.productionBindings.status === "VERIFIED_READBACK_LOCKED", "binding_product_mismatch");
      assert(/^[A-Za-z0-9-]{8,80}$/.test(buildId || ""), "invalid_build_id");
      assert(Number.isInteger(quantity) && quantity >= 1 && quantity <= 99, "invalid_quantity");
      assert(Number.isInteger(wheel) && wheel >= 15 && wheel <= 22, "invalid_wheel");
      assert(fitment?.[engine.variant.id]?.includes(wheel), "wheel_configuration_mismatch");
      assert(engine.requiredMissing().length === 0, "required_options_missing");
      assert(!engine.clearanceState || engine.clearanceState(wheel).confirmed, "wheel_clearance_confirmation_required");
      const selection = engine.selection();
      const uploads = selection.filter((row) => row.type === "file-upload").map((row) => {
        const file = engine.files[row.optionKey], url = engine.uploads[row.optionKey];
        assert(file || savedUpload(url), "upload_not_saved");
        if (file) assert(typeof global.File === "function" && file instanceof global.File && ["image/png", "image/jpeg", "image/webp"].includes(file.type) && file.size > 0 && file.size <= 10 * 1024 * 1024, "invalid_upload");
        return { key: row.optionKey, property: row.label, file, url: file ? null : url };
      });
      const plan = engine.cartPlan({ quantity, buildId, wheel: wheel + "\u2033" });
      assert(/^[A-Z]{3}$/.test(plan.currency), "currency_not_validated");
      assert(plan.currency === engine.catalog.currency, "currency_changed");
      const publicProperties = { ...plan.parent.properties };
      for (const [key, value] of Object.entries(publicProperties)) {
        const textRow = selection.find((row) => row.label === key && row.type === "text-area");
        if (textRow && String(value).length > 255 && String(value).length <= 1024) publicProperties[key] = String(value).slice(0, 252) + "\u2026";
        assert(key.length <= 100 && String(publicProperties[key]).length <= 255, "property_too_long");
      }
      const parent = {
        id: id(plan.parent.id),
        quantity,
        properties: { ...publicProperties, _ceika_build: buildId, _ceika_role: "kit", _ceika_catalog: engine.catalog.revision, _ceika_wheel: String(wheel), _ceika_parking: engine.parkingIncluded ? "included" : "none" }
      };
      selection.forEach((row) => {
        const option = engine.options.get(row.optionKey);
        if (!row.type) parent.properties["_ceika_option_" + row.optionKey] = engine.selected[option.key];
      });
      const canonicalChoices = { _wheel: String(wheel), ...engine.clearanceState(wheel).confirmed ? { _clearance: "acknowledged" } : {}, _parking: engine.variant.mode === "Front Kit" ? "not-applicable" : engine.parkingIncluded ? "with" : "without" };
      const canonicalText = {}, canonicalPendingUploads = [];
      for (const row of selection) {
        if (!row.type) canonicalChoices[row.optionKey] = engine.selected[row.optionKey];
        else if (row.type === "file-upload") {
          const url = engine.uploads[row.optionKey];
          if (savedUpload(url) && !engine.files[row.optionKey]) canonicalText[row.optionKey] = url;
          else {
            canonicalText[row.optionKey] = "pending-upload";
            canonicalPendingUploads.push(row.optionKey);
          }
        } else canonicalText[row.optionKey] = String(engine.text[row.optionKey] || "");
      }
      const wireData = { token: wireDictionary.token, nonce: wireAPI.nonceForBuild(buildId), text: canonicalText };
      wireData.wire = wireAPI.encodeWireSelection({ revision: wireDictionary.revision, choices: canonicalChoices, text: canonicalText }, wireDictionary, wireData.nonce);
      parent.properties[wireAPI.WIRE_KEY] = wireData.wire;
      const children = plan.children.map((line, index) => ({
        id: id(line.id),
        quantity,
        parent_id: parent.id,
        properties: { ...line.properties, _ceika_build: buildId, _ceika_role: "upgrade", _ceika_component: String(index) }
      }));
      parent.properties._ceika_charge_ids = children.map((line) => line.id).join("|");
      parent.properties._ceika_charge_count = String(children.length);
      const expected = [plan.parent, ...plan.children].map((line, index) => ({ id: id(line.id), quantity, unitPrice: line.unitPrice, properties: [parent, ...children][index].properties }));
      assert(expected.every((line) => Number.isSafeInteger(line.unitPrice) && line.unitPrice >= 0), "invalid_price");
      assert(expected.reduce((sum, line) => sum + line.unitPrice * quantity, 0) === plan.total, "price_sum_mismatch");
      assert(expected.every((line) => /^\d+$/.test(line.id)), "invalid_variant_id");
      return { buildId, productId: String(engine.catalog.productId), currency: plan.currency, uploads, canonicalPendingUploads, wireData, payload: { items: [parent, ...children] }, expected, total: plan.total };
    }
    function verifyCart(cart, plan) {
      assert(cart?.currency === plan.currency, "currency_changed");
      assert(Array.isArray(cart.items), "cart_line_count_mismatch");
      verifyWireCart(cart, plan);
      const lines = cart.items.filter((line) => line.properties?._ceika_build === plan.buildId);
      assert(lines.length === plan.expected.length, "cart_line_count_mismatch");
      const parent = lines.find((line) => line.properties?._ceika_role === "kit");
      assert(parent && id(parent.variant_id || parent.id) === plan.expected[0].id && !parent.parent_relationship?.parent_key, "kit_line_mismatch");
      const seen = /* @__PURE__ */ new Set();
      let originalTotal = 0;
      for (let index = 0; index < plan.expected.length; index++) {
        const expected = plan.expected[index];
        const line = index === 0 ? parent : lines.find((line2) => line2.properties?._ceika_role === "upgrade" && line2.properties?._ceika_component === String(index - 1));
        assert(line && !seen.has(line.key), "missing_or_duplicate_charge");
        seen.add(line.key);
        assert(id(line.variant_id || line.id) === expected.id && line.quantity === expected.quantity, "charge_or_quantity_mismatch");
        const properties = { ...expected.properties };
        if (index === 0) for (const upload of plan.uploads || []) {
          const actual = line.properties?.[upload.property];
          assert(upload.file ? savedUpload(actual) : actual === upload.url, "upload_not_saved");
          delete properties[upload.property];
        }
        assert(propsEqual(line.properties, properties), "configuration_changed");
        assert(Number.isSafeInteger(line.original_price) && line.original_price === expected.unitPrice, "shopify_price_changed");
        assert(Number.isSafeInteger(line.original_line_price) && line.original_line_price === expected.unitPrice * expected.quantity, "line_total_mismatch");
        assert(Number.isSafeInteger(line.final_line_price) && line.final_line_price >= 0 && line.final_line_price <= line.original_line_price, "invalid_discount_total");
        if (index > 0) assert(line.parent_relationship?.parent_key === parent.key, "upgrade_not_attached");
        originalTotal += line.original_line_price;
      }
      assert(originalTotal === plan.total && cart.original_total_price === cart.items.reduce((sum, line) => sum + line.original_line_price, 0), "cart_total_mismatch");
      assert(Number.isSafeInteger(cart.total_price) && cart.total_price >= 0 && cart.total_price <= cart.original_total_price, "invalid_cart_total");
      return { currency: cart.currency, originalTotal, discountedTotal: cart.total_price, lineCount: lines.length };
    }
    const buildSignature = (cart, buildId) => JSON.stringify(cart.items.filter((line) => line.properties?._ceika_build === buildId).map((line) => ({ key: line.key, id: id(line.variant_id || line.id), quantity: line.quantity, properties: line.properties, parent: line.parent_relationship?.parent_key || "" })).sort((a, b) => a.key.localeCompare(b.key)));
    function readBuild(cart, buildId, engine) {
      assert(/^[A-Za-z0-9-]{8,80}$/.test(buildId || ""), "invalid_build_id");
      const lines = cart.items.filter((line) => line.properties?._ceika_build === buildId);
      const parent = lines.find((line) => line.properties?._ceika_role === "kit");
      assert(parent && String(parent.product_id) === String(engine.catalog.productId), "edit_configuration_unavailable");
      assert(lines.every((line) => line === parent || line.parent_relationship?.parent_key === parent.key), "upgrade_not_attached");
      assert(lines.every((line) => line.quantity === parent.quantity), "charge_or_quantity_mismatch");
      const authoritative = wireAPI.decodeWireSelection(parent.properties?.[wireAPI.WIRE_KEY], cart.attributes?.[wireAPI.TEXT_KEY], wireDictionary);
      const selected = {}, text = {}, uploads = {}, changed = [];
      for (const option of engine.catalog.options) {
        if (option.type === "file-upload") {
          const url = parent.properties[option.label];
          if (savedUpload(url)) {
            uploads[option.key] = url;
            text[option.key] = "Saved reference image";
          } else if (url) changed.push(option.label);
        } else if (["text-box", "text-area"].includes(option.type)) {
          if (parent.properties[option.label]) text[option.key] = String(parent.properties[option.label]);
        } else if (option.type !== "group" && option.type !== "file-upload") {
          const saved = parent.properties["_ceika_option_" + option.key];
          const value = saved ? option.values.find((v) => v.key === saved) : option.values.find((v) => v.label === parent.properties[option.label]);
          if (value) selected[option.key] = value.key;
          else if (saved) changed.push(option.label);
        }
      }
      for (const family of engine.catalog.optionLayout?.splitAxles || []) {
        const legacy = parent.properties["_ceika_option_" + family + "-both"];
        if (legacy !== void 0) selected[family + "-both"] = legacy;
      }
      for (const key of Object.keys(selected)) delete selected[key];
      for (const key of Object.keys(text)) delete text[key];
      for (const key of Object.keys(uploads)) delete uploads[key];
      for (const option of engine.catalog.options) {
        if (authoritative.choices[option.key] !== void 0) selected[option.key] = authoritative.choices[option.key];
        if (authoritative.text[option.key] !== void 0) {
          if (option.type === "file-upload") {
            assert(savedUpload(authoritative.text[option.key]), "upload_not_saved");
            uploads[option.key] = authoritative.text[option.key];
            text[option.key] = "Saved reference image";
          } else text[option.key] = authoritative.text[option.key];
        }
      }
      const migrated = engine.migrateSelections ? engine.migrateSelections(selected) : selected;
      return {
        buildId,
        signature: buildSignature(cart, buildId),
        variantId: id(parent.variant_id || parent.id),
        quantity: parent.quantity,
        wheel: Number(authoritative.choices._wheel),
        parking: authoritative.choices._parking === "with",
        selected: migrated,
        text,
        uploads,
        changed,
        clearance: parent.properties._ceika_clearance || null
      };
    }
    class Transport {
      constructor({ config, request = global.fetch?.bind(global), context = { shop: global.Shopify?.shop, themeId: global.Shopify?.theme?.id, themeRole: global.Shopify?.theme?.role, designMode: global.Shopify?.designMode === true } }) {
        this.config = { ...config, root: normalizeRoot(config.root) };
        this.request = request;
        this.context = context;
        this.busy = false;
        this.submitted = /* @__PURE__ */ new Set();
      }
      checkScope() {
        const c = this.config;
        assert(c.enabled === true && c.reviewOnly === true && c.draftDesignReview !== true, "checkout_not_enabled");
        assert(c.approvedShop === "ceika-performance-store.myshopify.com" && c.approvedShop === this.context.shop, "wrong_test_store");
        assert(c.connection?.productId === String(c.productId) && c.connection.family === "bbk" && c.connection.purchaseEnabled === true && c.connection.activationPriceReady === true, "connection_not_active");
        assert(c.connection.release?.approved === true && c.connection.executionAllowed === true, "release_context_mismatch");
        assert(c.publicationVerified === true, "product_not_published");
        assert(typeof c.root === "string" && /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?$/i.test(c.root), "invalid_route");
      }
      async json(path, options = {}) {
        this.checkScope();
        const response = await this.request(this.config.root + path, { ...options, credentials: "same-origin", cache: "no-store", headers: { "Accept": "application/json", ...!(options.body instanceof global.FormData) ? { "Content-Type": "application/json" } : {}, ...options.headers } });
        assert(response.ok, "shopify_request_failed");
        return response.json();
      }
      async mutation(callback) {
        assert(!this.cartLockPending, "cart_busy");
        this.cartLockPending = true;
        try {
          return await withCartLock(callback);
        } finally {
          this.cartLockPending = false;
        }
      }
      add(plan) {
        return this.mutation(() => this.addUnlocked(plan));
      }
      replace(plan, original) {
        return this.mutation(() => this.replaceUnlocked(plan, original));
      }
      remove(plan) {
        return this.mutation(() => this.removeUnlocked(plan));
      }
      async addUnlocked(plan) {
        this.checkScope();
        assert(plan.productId === String(this.config.productId), "wrong_test_product");
        assert(!(plan.canonicalPendingUploads || []).length, "upload_not_saved");
        assert(!this.busy, "cart_busy");
        this.busy = true;
        try {
          const existing = await this.json("cart.js");
          assert(existing.currency === plan.currency, "currency_not_validated");
          if (existing.items?.some((line) => line.properties?._ceika_build === plan.buildId)) {
            const verified2 = verifyCart(existing, plan);
            this.submitted.add(plan.buildId);
            return { ...verified2, recovered: true };
          }
          this.submitted.delete(plan.buildId);
          await stageWireEnvelope(this, existing, plan);
          this.submitted.add(plan.buildId);
          await this.json("cart/add.js", { method: "POST", body: requestBody(plan) });
          const after = await this.json("cart.js");
          const verified = verifyCart(after, plan);
          assertWireTextRetained(existing, after);
          assert(existing.items.every((line) => after.items.some((next) => next.key === line.key && next.quantity === line.quantity)), "cart_changed");
          return verified;
        } finally {
          this.busy = false;
        }
      }
      async checkout(plan) {
        this.checkScope();
        assert(plan.productId === String(this.config.productId), "wrong_test_product");
        assert(!this.busy, "cart_busy");
        this.busy = true;
        try {
          const verified = verifyCart(await this.json("cart.js"), plan);
          return { ...verified, path: this.config.root + "checkout" };
        } finally {
          this.busy = false;
        }
      }
      async replaceUnlocked(plan, original) {
        this.checkScope();
        assert(!this.editBusy && !this.busy, "cart_busy");
        assert(plan.buildId !== original.buildId, "invalid_build_id");
        this.editBusy = true;
        try {
          const before = await this.json("cart.js");
          const oldLines = before.items.filter((line) => line.properties?._ceika_build === original.buildId);
          if (!oldLines.length) {
            assert(this.submitted.has(plan.buildId), "edit_configuration_unavailable");
            return { ...verifyCart(before, plan), recovered: true };
          }
          assert(buildSignature(before, original.buildId) === original.signature, "configuration_changed");
          await this.addUnlocked(plan);
          const staged = await this.json("cart.js");
          verifyCart(staged, plan);
          assert(buildSignature(staged, original.buildId) === original.signature, "configuration_changed");
          const parent = staged.items.find((line) => line.properties?._ceika_build === original.buildId && line.properties?._ceika_role === "kit");
          assert(parent && String(parent.product_id) === String(this.config.productId), "wrong_test_product");
          await this.json("cart/change.js", { method: "POST", body: JSON.stringify({ id: parent.key, quantity: 0 }) });
          const after = await this.json("cart.js");
          const verified = verifyCart(after, plan);
          assert(!after.items.some((line) => line.properties?._ceika_build === original.buildId), "cart_changed");
          assert(before.items.filter((line) => line.properties?._ceika_build !== original.buildId && line.properties?._ceika_build !== plan.buildId).every((line) => after.items.some((next) => next.key === line.key && next.quantity === line.quantity)), "cart_changed");
          await pruneWireEnvelope(this, after);
          return verified;
        } finally {
          this.editBusy = false;
        }
      }
      async removeUnlocked(plan) {
        this.checkScope();
        assert(plan.productId === String(this.config.productId), "wrong_test_product");
        assert(!this.busy, "cart_busy");
        this.busy = true;
        try {
          const cart = await this.json("cart.js");
          if (!cart.items?.length) return;
          const owned = cart.items.filter((line) => line.properties?._ceika_build === plan.buildId);
          if (!owned.length) return;
          const parent = owned.find((line) => line.properties?._ceika_role === "kit");
          assert(parent && id(parent.variant_id || parent.id) === plan.expected[0].id, "kit_line_mismatch");
          assert(owned.every((line) => line === parent || line.parent_relationship?.parent_key === parent.key), "upgrade_not_attached");
          await this.json("cart/change.js", { method: "POST", body: JSON.stringify({ id: parent.key, quantity: 0 }) });
          const after = await this.json("cart.js");
          assert(!after.items?.some((line) => line.properties?._ceika_build === plan.buildId), "cart_changed");
          assert(cart.items.filter((line) => !owned.includes(line)).every((line) => after.items.some((next) => next.key === line.key && next.quantity === line.quantity)), "cart_changed");
          await pruneWireEnvelope(this, after);
        } finally {
          this.busy = false;
        }
      }
    }
    function requestBody(plan) {
      if (!(plan.uploads || []).some((upload) => upload.file)) return JSON.stringify(plan.payload);
      const body = new global.FormData();
      plan.payload.items.forEach((item, index) => {
        for (const [key, value] of Object.entries(item)) {
          if (key === "properties") for (const [property, text] of Object.entries(value)) {
            const upload = index === 0 && plan.uploads.find((row) => row.property === property && row.file);
            body.append(`items[${index}][properties][${property}]`, upload ? upload.file : String(text));
          }
          else body.append(`items[${index}][${key}]`, String(value));
        }
      });
      return body;
    }
    function attach(root, engine) {
      configureWireDictionary(engine.catalog);
      const config = JSON.parse(root.querySelector("[data-native-cart-config]").textContent);
      if (engine.catalog.factoryPolicy?.enabled) config.enabled = config.enabled === true && engine.catalog.checkoutEnabled === true;
      config.root = normalizeRoot(config.root);
      const words = JSON.parse(root.querySelector("[data-native-cart-labels]").textContent);
      const fitment = JSON.parse(root.querySelector("[data-pilot-fitment]").textContent);
      const transport = new Transport({ config });
      const form = root.querySelector("form");
      const button = root.querySelector("[data-native-add]");
      const status = root.querySelector("[data-native-cart-status]");
      const signal = root._nativeAbort.signal;
      if (engine.catalog.draftDesignReview?.enabled === true || root.dataset.draftDesignReview === "true") {
        const lock = () => {
          button.disabled = true;
          button.textContent = words.draft_disabled;
          status.textContent = "";
        };
        form.removeAttribute("action");
        form.addEventListener("submit", (event) => {
          event.preventDefault();
          event.stopImmediatePropagation();
          lock();
        }, { signal, capture: true });
        lock();
        return { changed: lock };
      }
      let busy = false, pending = null, editing = null, editLoading = false, editFailed = false;
      const editId = new URL(global.location.href).searchParams.get("ceika_edit");
      const fingerprint = () => JSON.stringify({ currency: engine.catalog.currency, variant: engine.variant.id, selection: engine.selection(), uploads: Object.entries(engine.files || {}).map(([key, file]) => [key, file?.name, file?.size, file?.lastModified]), parking: engine.parkingIncluded, wheel: root.dataset.wheel, clearance: engine.clearanceConfirmation });
      const state = () => {
        button.disabled = config.enabled !== true || !config.publicationVerified || config.connection?.activationPriceReady !== true || busy || editLoading || editFailed || root.dataset.priceLoadState !== "ready" || root.dataset.extrasPriceState !== "ready" || root.dataset.nativeError === "true" || root.dataset.hardwareBlocked === "true";
        button.textContent = busy ? words.adding : editing ? words.save : words.add;
        form.setAttribute("aria-busy", String(busy));
      };
      const changed = () => {
        if (!busy) status.textContent = "";
        state();
      };
      form.addEventListener("submit", async (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (busy || button.disabled) return;
        busy = true;
        state();
        status.textContent = words.adding;
        try {
          const current = fingerprint();
          if (pending && pending.fingerprint !== current && transport.submitted.has(pending.plan.buildId)) throw new Error("check_existing_cart");
          if (!pending || pending.fingerprint !== current) {
            pending = { fingerprint: current, plan: prepare(engine, { buildId: global.crypto.randomUUID(), quantity: editing?.quantity || 1, wheel: Number(root.dataset.wheel), fitment }) };
          }
          if (editing) await transport.replace(pending.plan, editing);
          else await transport.add(pending.plan);
          status.textContent = words.added;
          global.location.assign(config.root + "cart");
        } catch (error) {
          status.textContent = error.message === "required_options_missing" ? words.required + engine.requiredMissing().join(", ") : words.errors[error.message] || (editing ? words.edit_failed : words.errors.generic);
          if (error.message === "required_options_missing") root.extrasController.revealMissing();
          else if (error.message === "wheel_clearance_confirmation_required") {
            const field = root.querySelector("[data-native-clearance-confirm]");
            field?.scrollIntoView({ block: "center" });
            field?.focus({ preventScroll: true });
          } else status.focus();
          busy = false;
          state();
        }
      }, { signal, capture: true });
      if (editId) {
        editLoading = true;
        const notice = root.querySelector("[data-native-edit-notice]");
        notice.hidden = false;
        notice.querySelector("span").textContent = words.checking;
        (async () => {
          try {
            transport.checkScope();
            const saved = readBuild(await transport.json("cart.js"), editId, engine);
            if (signal.aborted) return;
            root.restoreKit(saved);
            root.extrasController.restore(saved);
            const changes = saved.changed.concat(Object.keys(saved.selected).filter((key) => engine.selected[key] !== saved.selected[key]));
            editing = saved;
            notice.querySelector("span").textContent = changes.length ? words.edit_changed : words.editing;
          } catch (error) {
            if (signal.aborted) return;
            editFailed = true;
            notice.querySelector("span").textContent = words.edit_failed;
          } finally {
            editLoading = false;
            if (!signal.aborted) state();
          }
        })();
      }
      state();
      return { changed };
    }
    global.CeikaNativeCart = { savedUpload, requestBody, normalizeRoot, resolveBoundDictionary, applyPrices, applyCataloguePreviewPrices, applySavedDesignPrices, loadPrices, prepare, verifyCart, buildSignature, readBuild, Transport, attach };
  })(typeof window !== "undefined" ? window : globalThis);
})();
